export default __webpack_public_path__ + "static/media/Protoio.8bc3d114.svg";